import countries from 'i18n-iso-countries'
import { useMemo } from 'react'

const COUNTRY_LABEL_OVERRIDES: Record<string, string> = {
  // i18n-iso-countries returns official names by default (e.g. "Koninkrijk België"),
  // but in the UI we want the common/short name for usability & alphabetical sorting.
  BE: 'België',
}

export function useCountryCodes(locale: string, locales: countries.LocaleData[] = []) {
  return useMemo(() => {
    locales.forEach((localeData) => {
      countries.registerLocale(localeData)
    })

    const countryCodes = countries.getNames(locale, {
      select: 'official',
    })

    return [
      ...Object.keys(countryCodes)
        .map((key: string) => ({
          value: key,
          label: COUNTRY_LABEL_OVERRIDES[key] ?? countryCodes[key],
        }))
        .sort((a, b) => a.label.localeCompare(b.label, locale, { sensitivity: 'base' })),
      { value: 'XE', label: 'Onbekend' }, // Add unknown value for Oazis
    ]
  }, [locales, locale])
}
